<script>
    import CardCinema from "../components/CardCinema.svelte";
    import { withResolvers } from "@otto-ec/assets-core-utils/promise";
    import { onMount } from "svelte";
    import { getAggregationFeatureLabels, getFeatureOrder, getNextPiTrackingLabels } from "../utils/externalTrackingHelper.js";

    let { data } = $props();
    const {
        recommendations,
        headline,
        featuresState,
        metaData,
        additionalClickTracking,
        tracking,
        hasPersonalisedRecommendations = false,
    } = data;

    let hasElevationLevel = ![null, undefined, ""].includes(headline);

    let index = $state("0");
    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");
    let additionalTrackingLabels = $state(null);
    let cinemaContainer;
    let additionalNextPiTrackingLabels = $state(null);
    const [cinemaContainerMounted, mountSuccess] = withResolvers();

    onMount(() => {
        featureIndex = getFeatureOrder(cinemaContainer);
        additionalTrackingLabels = getAggregationFeatureLabels(cinemaContainer);
        additionalNextPiTrackingLabels = getNextPiTrackingLabels(cinemaContainer);
        cinemaInjectionContainerWidth = parseInt(cinemaContainer?.offsetWidth) || 1000;
        mountSuccess();
    });
</script>

<div bind:this={cinemaContainer}>
    <div class="reco_card_cinema_wrapper">
        <CardCinema
            {headline}
            {recommendations}
            {cinemaInjectionContainerWidth}
            {additionalClickTracking}
            {featuresState}
            {featureIndex}
            cinemaIndex={index}
            cinemaMeta={metaData}
            {additionalNextPiTrackingLabels}
            {additionalTrackingLabels}
            {tracking}
            personalisedUser={hasPersonalisedRecommendations}
            {hasElevationLevel}
            {cinemaContainerMounted}
        />
    </div>
</div>

<style lang="scss">
    .reco_card_cinema_wrapper {
        max-height: 672px;
        position: relative;
    }
</style>
